import {Icon, MenuListItem, Text} from '@albert-io/atomic';
import React from 'react';
import {Link} from 'react-router';

import './subject-menu-section-item.scss';

interface SubjectMenuSectionItemProps {
  onClick: () => void;
  text: string;
  isSelected: boolean;
  to?: string;
  sectionProps?: Record<string, any>;
  'data-testid'?: string;
}

export const SubjectMenuSectionItem = ({
  onClick,
  text,
  isSelected,
  to,
  sectionProps = {},
  'data-testid': dataTestId
}: SubjectMenuSectionItemProps) => {
  return (
    <div className='u-gap_space-x1 flex flex-col'>
      <MenuListItem
        as={Link}
        className='subject-menu-section u-pad_2 flex !justify-between'
        onClick={onClick}
        to={to}
        selected={isSelected}
        data-testid={dataTestId}
      >
        <div className='u-gap_space-x1 flex items-center'>
          {sectionProps.leftIcon && (
            <Icon
              icon={sectionProps.leftIcon}
              color={isSelected ? 'brand' : 'primary'}
              iconStyle='regular'
            />
          )}
          <Text bold size='s' color={isSelected ? 'brand' : 'primary'}>
            {text}
          </Text>
        </div>
        {sectionProps.rightContent && sectionProps.rightContent}
      </MenuListItem>
      {sectionProps.children && (
        <div className='subject-menu-section__children'>{sectionProps.children}</div>
      )}
    </div>
  );
};
